import { forwardRef } from 'react';
import Textarea from '../../../../components/textarea/Textarea';
import useSectionHighlightRef from '../../../../hooks/useSectionHighlightRef';

const Terms = forwardRef(({ tempData, setTempData }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    return (
        <div ref={sectionRef}>
            <h2 className='orgPackUpH2'>Terms and Conditions</h2>
            <div className='orgPackUpSecDiv'>
                <div>
                    <p className='tagsNoteP'>
                        Note: Type each point in new(press enter) line (each next point should come in new line). Don't
                        number the points as it will be numbered automatically on the user end
                    </p>
                </div>
                <Textarea
                    label='Terms'
                    name='terms'
                    value={tempData.terms}
                    placeholder='Terms and conditions of the package'
                    setFormData={setTempData}
                    directInDiv='orgPackUpInputDiv'
                    labelCss='orgPackUpLabel'
                    inputCss='orgPackUpInput'
                    min={20}
                    limit={1500}
                    error={highlightField === 'terms'}
                />
            </div>
        </div>
    );
});

export default Terms;
